import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import api from "@/lib/api";

export default function IndustryDetail() {
  const { slug } = useParams();
  const [ind, setInd] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setInd(null); api.get(`/industries/${slug}`).then((r) => setInd(r.data)).catch(() => setNf(true)); }, [slug]);
  if (nf) return <PublicLayout><div className="pt-40 pb-20 text-center"><h1 className="font-display text-2xl font-bold">Industry not found</h1><Link to="/industries" className="text-brand-emerald mt-4 inline-block">← All industries</Link></div></PublicLayout>;
  if (!ind) return <PublicLayout><div className="pt-40 grid place-items-center"><div className="h-10 w-10 rounded-full border-2 border-brand-emerald border-t-transparent animate-spin" /></div></PublicLayout>;
  return (
    <PublicLayout waMessage={`Hi Dreamzz HR & Consultancy, I need staffing for the ${ind.name} sector.`}>
      <Seo title={ind.seo_title || `${ind.name} Recruitment`} description={ind.meta_description || ind.description}
        schema={breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Industries", url: "/industries" }, { name: ind.name, url: window.location.href }])} />
      <PageHeader eyebrow="Industry" title={`${ind.name} Recruitment & Staffing`} subtitle={ind.description} />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-slate-300 leading-relaxed text-lg">
          Dreamzz HR & Consultancy provides specialised manpower recruitment and staffing solutions for the {ind.name} sector across Karnataka. Whether you need skilled, semi-skilled or entry-level workforce, our structured hiring process connects you with the right candidates quickly and reliably.
        </p>
        <p className="text-slate-300 leading-relaxed mt-4">
          From sourcing and screening to shortlisting and placement, we manage the entire recruitment lifecycle so you can focus on running your {ind.name.toLowerCase()} business. Job seekers looking for roles in this sector can register with us to be matched with relevant openings.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/for-employers"><Button className="bg-brand-emerald hover:bg-[#C62828] text-white font-semibold">Hire {ind.name} Staff <ArrowRight size={16} className="ml-2" /></Button></Link>
          <Link to="/jobs"><Button variant="outline" className="border-white/15">Find {ind.name} Jobs</Button></Link>
        </div>
      </section>
    </PublicLayout>
  );
}
